import React from 'react';
import { motion } from 'framer-motion';
import { MatrixRain } from './MatrixRain';
import { BookOpenIcon, HeadphonesIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col items-center overflow-hidden" data-id="element-338">
      {/* Background */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/mmZsZjhR9eRY4yFwjZNjVf/CONTRA_PORTADA.png')`
    }} data-id="element-339" />
      <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/75 to-black" data-id="element-340" />

      {/* Matrix Rain */}
      <MatrixRain data-id="element-341" />

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 pt-16 pb-12 md:pt-24 md:pb-16 text-center" data-id="element-342">
        {/* Main question */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.15] mb-8 text-glow" data-id="element-343">
          What if reality isn't something that happens to you — but a game you
          were never given the rules to?
        </motion.h1>

        {/* Subtext */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-neutral-300 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-344">
          A complete map of consciousness, power, and hidden control. The book
          that connects simulation theory with ancient wisdom — and shows you
          how to play awake.
        </motion.p>

        {/* Format badges */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex items-center justify-center gap-3 mb-8" data-id="element-345">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-900/70 border border-neutral-700/50 text-neutral-300 text-sm" data-id="element-346">
            <BookOpenIcon className="w-4 h-4 text-teal-400" data-id="element-347" />
            Ebook
          </span>
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-900/70 border border-neutral-700/50 text-neutral-300 text-sm" data-id="element-348">
            <HeadphonesIcon className="w-4 h-4 text-teal-400" data-id="element-349" />
            Audiobook
          </span>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 1.0
      }} className="mb-12" data-id="element-350">
          <a href="#get-access" className="inline-flex items-center gap-3 px-10 py-4 text-base md:text-lg font-bold text-black bg-gradient-to-r from-teal-400 to-cyan-400 rounded-xl shadow-lg shadow-teal-500/30 hover:shadow-teal-500/50 hover:scale-105 transition-all duration-300 uppercase tracking-wide" data-id="element-351">
            ▶ I'm Ready to Play →
          </a>
        </motion.div>

        {/* Book Cover */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 1.2
      }} className="relative mx-auto" data-id="element-352">
          <div className="relative inline-block" data-id="element-353">
            <div className="absolute -inset-8 bg-teal-500/15 blur-3xl rounded-full" data-id="element-354" />
            <img src="https://cdn.magicpatterns.com/uploads/mQHeJx8HC6YFDB8aG55hZM/portada.png" alt="Who We Are, Who They Are, and What They Hide — Book Cover" className="relative w-56 md:w-72 lg:w-80 h-auto shadow-2xl shadow-teal-500/20" data-id="element-355" />
          </div>
        </motion.div>
      </div>
    </section>;
}